import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { PanelLayout } from "@/interactors/PanelLayout";

export const RouteComponent = () => {
  return (
    <PanelLayout>
      <Outlet />
    </PanelLayout>
  );
};

export const Route = createFileRoute("/_authed/student")({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (context.userType && context.userType === "STAFF") {
      throw redirect({
        to: "/",
        search: {
          redirect: location.href.includes("/logout")
            ? undefined
            : location.href,
        },
      });
    }
  },
});
